import {useUpdateOrderMutation} from 'hooks/ventrata/useUpdateOrderMutation'
import React, {useEffect} from 'react'
import {UpdateOrderRequest} from 'types/params'
import {singleCall} from 'utils/singleCall'
import {useConfirmingPath, useSiteUrl} from './EnvironmentProvider'
import {OrderProvider} from './OrderProvider'

type Props = {
  children: React.ReactNode
}

export const VentrataPaymentContext = React.createContext(null)

/**
 * Sets the Adyen return URL on the order before the drop-in mounts.
 *
 * reCAPTCHA tokens are no longer generated here: they are minted just in time by the
 * protected API methods themselves, so there is no session-wide token to send ahead
 * of the payment and nothing to wait on before rendering.
 */
export const VentrataPaymentProvider = ({children}: Props) => {
  const order = OrderProvider.useOrder()
  const setOrder = OrderProvider.useOrderSetter()
  const updateOrderMutation = useUpdateOrderMutation()
  const updateOrder = updateOrderMutation.mutate
  const confirmingPath = useConfirmingPath()
  const siteUrl = useSiteUrl()

  useEffect(() => {
    if (!order.cardPayment || order.cardPayment.gateway !== 'adyen' || order.returnUrl) {
      return
    }

    singleCall('setAdyenReturnUrl', () => {
      const updateParams: UpdateOrderRequest = {
        orderId: order.id,
        returnUrl: `${siteUrl}${confirmingPath}`,
      }

      updateOrder(updateParams, {onSuccess: setOrder})
    })
  }, [setOrder, updateOrder, order, confirmingPath, siteUrl])

  return <VentrataPaymentContext.Provider value={null}>{children}</VentrataPaymentContext.Provider>
}
